import { commonLabels } from "../component/Patient/PatientApplications/PatientApplicationDetails/trackComponents/consts/trackFieldLabels";
import { preparationDetailsFieldNames } from "../component/Patient/PatientApplications/PatientApplicationDetails/trackComponents/consts/trackFieldNames";
import { INTERNAL_PROGRAM, prioritiesMap } from "../constant/assistanceProgram";
import { EMPTY_VALUE } from "../constant/trackTab";
import { dateFormatter } from "./date";
import { isValidDate } from "./formaters";

export const formatAPType = (t, { priority, internal }) => {
  if (internal) {
    return t(`patientPotentialSavings.${prioritiesMap[INTERNAL_PROGRAM].text}`);
  } else {
    return prioritiesMap[priority] ? t(`patientPotentialSavings.${prioritiesMap[priority].text}`) : "";
  }
};

export const getApplicationDisplayName = (application, hideAssociatedDrugs = false) => {
  const hasAssociatedDrugs = application.associatedDrugs.length > 0;
  const baseName = hasAssociatedDrugs ? application.potentialSaving.name : application.displayName;

  return hasAssociatedDrugs && !hideAssociatedDrugs
    ? `${baseName} (${application.associatedDrugs.join(", ")})`
    : baseName;
};

export const getFormattedTextForCopy = ({ t, application, fieldNames, tableKey, statusKey, Statuses }) => {
  const fieldLabels = commonLabels[tableKey];

  return Object.keys(fieldNames)
    .map((key) => {
      const shouldSkipPersonNameYouSpokeTo =
        key === preparationDetailsFieldNames.personNameYouSpokeTo && statusKey === Statuses.prepare.key;
      if (shouldSkipPersonNameYouSpokeTo) {
        return null;
      }

      const label = t(fieldLabels?.[key] ?? key);
      const value = application?.[fieldNames[key]] ? application[fieldNames[key]] : EMPTY_VALUE;
      const formattedValue = isValidDate(value) ? dateFormatter(value) : value;

      return formattedValue ? `${label}: ${formattedValue}` : null;
    })
    .filter(Boolean)
    .join("\n");
};
